const TERMS = [
  "EVENT INTEGRITY",
  "TRUTH LAYER",
  "LOCATION VALIDATION",
  "ANOMALY DETECTION",
  "AUDITABILITY",
  "WGS-84 PRECISION",
  "GEOFENCE COMPLIANCE",
  "CLAIM RECONCILIATION",
];

const Marquee = () => {
  const row = [...TERMS, ...TERMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-border bg-background py-4 select-none"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((term, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground flex items-center"
              >
                <span className="px-6">{term}</span>
                <span className="text-telemetry">●</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
